import React, { useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { facebookAPI } from '../services/api';

const FacebookOAuthCallback = () => {
  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const error = urlParams.get('error');

      if (error) {
        console.error('Facebook OAuth error:', error);
        window.opener.postMessage(
          { type: 'facebook_error', error: error },
          window.location.origin
        );
        window.close();
        return;
      }

      if (!code) {
        console.error('No authorization code received');
        window.opener.postMessage(
          { type: 'facebook_error', error: 'No authorization code received' },
          window.location.origin
        );
        window.close();
        return;
      }

      if (!state) {
        console.error('No OAuth state received');
        window.opener.postMessage(
          {
            type: 'facebook_error',
            error:
              'Missing OAuth state (CSRF). Close this window and connect Facebook again from the app.',
          },
          window.location.origin
        );
        window.close();
        return;
      }

      try {
        const result = await facebookAPI.exchangeFacebookCode(code, state);

        console.log('Facebook connection successful:', result);

        // Notify the parent window
        window.opener.postMessage(
          { type: 'facebook_connected', data: result },
          window.location.origin
        );

        // Close the popup
        window.close();
      } catch (error) {
        console.error('Facebook connection failed:', error);
        window.opener.postMessage(
          { type: 'facebook_error', error: error.message },
          window.location.origin
        );
        window.close();
      }
    };

    handleCallback();
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#0d1117',
        color: '#f0f6fc',
      }}
    >
      <CircularProgress sx={{ mb: 2, color: '#1877f2' }} />
      <Typography variant="h6" sx={{ textAlign: 'center' }}>
        Connecting to Facebook...
      </Typography>
      <Typography
        variant="body2"
        sx={{ textAlign: 'center', mt: 1, color: '#7d8590' }}
      >
        Please wait while we complete the connection.
      </Typography>
    </Box>
  );
};

export default FacebookOAuthCallback;
